import { ReactNode } from 'react'
import ReactSelect, { SingleValue } from 'react-select'
import styled from 'styled-components'

export type SelectOptions = {
  label: ReactNode
  value: string
}[]

type SelectProps = {
  label: string
  onChange: (value: string) => void
  placeholder: string
  options: SelectOptions
  errorMessage?: ReactNode
  [x: string]: any
}

const StyledSelect = styled.div`
  align-items: center;
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: 1fr 6fr;

  .select-label {
    text-align: right;
    justify-self: end;
    padding-right: 10px;
  }

  .error-label {
    color: red;
    font-size: 9pt;
    margin-top: 2px;
    grid-column-start: 2;
  }

  @media only screen and (max-width: 600px) {
    min-width: unset;
    grid-template-columns: 1fr;

    span:first-child {
      justify-self: start;
      font-size: 10pt;
      margin-bottom: 2px;
      color: ${props => props.theme.fontColor};
    }

    .error-label {
      grid-column-start: 1;
    }
  }
`

export const UnstyledSelect = ({ label, onChange, errorMessage, ...props }: SelectProps) => {
  const onSelect = (newValue: SingleValue<{ label: ReactNode; value: string }>) => onChange(newValue?.value!)

  return (
    <>
      <span className="select-label">{label}:</span>
      <ReactSelect
        onChange={onSelect}
        {...props}
      />
      {errorMessage && <span className="error-label">{errorMessage}</span>}
    </>
  )
}

export const Select = (props: SelectProps) => {
  return (
    <StyledSelect>
      <UnstyledSelect {...props} />
    </StyledSelect>
  )
}
